import React from "react";

export default function Footer() {
  return (
    <div className="fixed bottom-0 left-0 right-0 text-center bg-white p-4 shadow-md">
      <img className="w-1/2 h-10 mx-auto" src="/logo_qovoltis.svg" alt="Qovoltis" />
    </div>
  );
}
